import { ControllerRenderProps } from "react-hook-form";
import { Ethnicity } from "@/generated-api";
import { useTranslation } from "@/hooks/useTranslation";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export default function EthnicitySelector({
  formField,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formField: ControllerRenderProps<any>;
}) {
  const t = useTranslation();

  return (
    <Select
      onValueChange={(value) => formField.onChange(value || undefined)}
      value={formField.value || ""}
    >
      <SelectTrigger className="focus:ring-0 focus:ring-offset-0 focus-visible:ring-0 focus-visible:ring-offset-0">
        <SelectValue placeholder={t.SEARCH_PAGE.PLACEHOLDERS.ETHNICITY_INPUT} />
      </SelectTrigger>
      <SelectContent className="dark w-fit">
        <SelectGroup>
          {Object.values(Ethnicity).map((e) => (
            <SelectItem className="hover:cursor-pointer py-3" key={e} value={e}>
              {t.ETHNICITIES[e as Ethnicity] || e}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
